import { useFormikContext } from 'formik';
import { FinalExpenses } from '../../../../types/FinalExpenses';
import DatePicker from '../../../../components/atoms/DatePicker/DatePicker';
import FormikField from '../../../../components/atoms/Form/FormikField';
import FormikInput from '../../../../components/atoms/Form/FormikInput';
import Label from '../../../../components/atoms/Label';
import Trip from '../../../../types/Trip';

export default function FinalExpensesAlterations({
  readonly = false,
  trip,
}: {
  readonly?: boolean;
  trip: Trip;
}) {
  const {
    values: { alterations },
    setFieldValue,
  } = useFormikContext<FinalExpenses>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-4">
        <div>
          <Label htmlFor="startDate">Start Date</Label>
          <DatePicker
            id="startDate"
            selected={
              alterations?.startDate
                ? new Date(alterations.startDate)
                : new Date(trip.startDate)
            }
            onChange={(newDate) =>
              setFieldValue('alterations.startDate', newDate)
            }
            dateFormat="MMMM d, yyyy"
            className="input input-bordered w-full max-w-xs"
            disabled={readonly || !alterations}
          />
        </div>
        <div>
          <Label htmlFor="endDate">End Date</Label>
          <DatePicker
            id="endDate"
            selected={
              alterations?.endDate
                ? new Date(alterations.endDate)
                : new Date(trip.endDate)
            }
            onChange={(newDate) =>
              setFieldValue('alterations.endDate', newDate)
            }
            dateFormat="MMMM d, yyyy"
            className="input input-bordered w-full max-w-xs"
            disabled={readonly || !alterations}
          />
        </div>
      </div>
      <FormikField
        name="alterations.extraTravelDays"
        label="Total Travel Days"
        type="number"
        component={FormikInput}
        disabled={readonly}
      />
    </div>
  );
}
